import { useMemo } from "react";
import { zeroAddress } from "viem";

import { getContract } from "config/contracts";

import { useMulticall } from "./multicall";
import { FREQUENT_UPDATE_INTERVAL } from "./timeConstants";

export type BlockTimestampData = {
  blockTimestamp: bigint;
  localTimestamp: bigint;
};

export type BlockTimestampResult = {
  blockTimestampData?: BlockTimestampData;
};

export function useBlockTimestampRequest(chainId: number, { skip }: { skip?: boolean } = {}): BlockTimestampResult {
  const contractAddress = getContract(chainId, "Multicall");

  // Fallback: chain has no Multicall helper deployed
  if (contractAddress === zeroAddress) {
    const now = BigInt(Math.floor(Date.now() / 1000));
    return { blockTimestampData: { blockTimestamp: now, localTimestamp: now } };
  }

  const { data } = useMulticall(chainId, "useBlockTimestamp", {
    key: !skip ? [] : null,

    refreshInterval: FREQUENT_UPDATE_INTERVAL,

    request: () => ({
      multicall: {
        contractAddress,
        abiId: "Multicall",
        calls: {
          getCurrentBlockTimestamp: {
            methodName: "getCurrentBlockTimestamp",
            params: [],
          },
        },
      },
    }),

    parseResponse: (res) => {
      const blockTimestamp = res.data.multicall.getCurrentBlockTimestamp.returnValues[0];

      return {
        blockTimestamp: blockTimestamp,
        localTimestamp: BigInt(Math.floor(Date.now() / 1000)),
      };
    },
  });

  return useMemo(() => ({ blockTimestampData: data }), [data]);
}

export function adjustBlockTimestamp(blockTimestampData: BlockTimestampData) {
  const nowInSeconds = BigInt(Math.floor(Date.now() / 1000));

  return blockTimestampData.blockTimestamp + (nowInSeconds - blockTimestampData.localTimestamp);
}
